// extracted by mini-css-extract-plugin
export default {"AppSpinnerBody":"AppSpinner_AppSpinnerBody__Wzad9"};